/**
 * HTML <-> editor blocks for the documents store, registered by the app
 * (registerBodyHtmlCodec.js, imported once from src/index.js) instead of
 * imported by the store.
 *
 * The conversion needs the editor's node classes, and those pull in the
 * attachment uploader and, through it, the API client and the auth surfaces.
 * The store is part of what MCP handlers import, and MCP's reachable code is
 * pinned (mcpAttackSurface.test.js) to keep away from those — so the store
 * only knows this slot. At run time MCP's reads and writes still get exact
 * HTML and real blocks through it; the conversion code just is not part of
 * MCP's import graph.
 *
 * Unregistered (a unit test that does not need it), the store reads the HTML
 * snapshot kept on the docbody row, and an HTML-only write stores the HTML
 * whole (documentsStore.saveDocumentBody), which the next editor save moves
 * to blocks.
 */
let codec = null;

/** `{ toHtml(snapshot) -> html, fromHtml(docId, html) -> snapshot }`, or null to clear. */
export function setBodyHtmlCodec(next) {
  codec = next && typeof next.toHtml === 'function' && typeof next.fromHtml === 'function' ? next : null;
}

export function bodyHtmlCodec() {
  return codec;
}
